import React, { PropTypes } from 'react'
import _ from 'lodash'

import ArrayUtils from 'PMT/utils/ArrayUtils'
import CurrencyUtils from 'PMT/utils/CurrencyUtils'
import I18n from 'PMT/i18n/I18n'

import Graph from './components/Graph'
import KeyFigures from './components/KeyFigures'
import StatsTable from './components/StatsTable'

const View = ({
  data,
  orderModes,
  sourcesList,
  paymentMethods,
  apiError,
  salesFilters,
  salesFiltersState,
  weekdaysFilters,
  weekdaysFiltersState,
  changeFilters,
  currencyCode
}) => {
  const thead = [
    '',
    I18n.tr('order.statistics.nbOrders'),
    I18n.tr('order.statistics.turnover'),
    I18n.tr('order.statistics.average'),
  ]

  return (
    !_.isNull(data) && !_.isEmpty(data.items) ? (
      <div>
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <KeyFigures
              color="primary"
              icon="fa-shopping-cart"
              text={I18n.tr('order.statistics.nbOrders')}
              figure={data.sums.total.nbOrders}
            />
          </div>
          <div className="col-xs-12 col-sm-4">
            <KeyFigures
              color="green"
              icon="fa-eur"
              text={I18n.tr('order.statistics.turnover')}
              figure={CurrencyUtils.formatMillionPriceWithCurrency(
                  data.sums.total.turnoverTTC, currencyCode)}
            />
          </div>
          <div className="col-xs-12 col-sm-4">
            <KeyFigures
              color="yellow"
              icon="fa-credit-card"
              text={I18n.tr('order.statistics.average')}
              figure={CurrencyUtils.formatMillionPriceWithCurrency(
                  data.sums.total.averageTTC, currencyCode)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <Graph
              graphId="area"
              name={I18n.tr('order.statistics.turnover_average-check')}
              filters={salesFilters}
              filtersState={salesFiltersState}
              changeFilters={(filter) => changeFilters('salesFilters', [ filter ])}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-md-9">
            <StatsTable
              name={I18n.tr('order.statistics.modes')}
              thead={thead}
              iterator={orderModes}
              data={data.sums.modes}
              currencyCode={currencyCode}
            />
          </div>
          <div className="col-xs-12 col-md-3">
            <Graph graphId="donut-modes" name={I18n.tr('order.statistics.turnover')} />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-md-9">
            <StatsTable
              name={I18n.tr('order.statistics.sources')}
              thead={thead}
              iterator={sourcesList}
              data={data.sums.sources}
              currencyCode={currencyCode}
            />
          </div>
          <div className="col-xs-12 col-md-3">
            <Graph graphId="donut-sources" name={I18n.tr('order.statistics.turnover')} />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-md-9">
            <StatsTable
              name={I18n.tr('order.statistics.payments')}
              thead={thead}
              iterator={paymentMethods}
              data={data.sums.payments}
              currencyCode={currencyCode}
            />
          </div>
          <div className="col-xs-12 col-md-3">
            <Graph graphId="donut-payments" name={I18n.tr('order.statistics.turnover')} />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <Graph
              graphId="area-by-weekday"
              name={I18n.tr('order.statistics.turnover_average-check_by-weekday')}
              filters={weekdaysFilters}
              filtersState={weekdaysFiltersState}
              changeFilters={(filter) => changeFilters('weekdaysFilters', ArrayUtils.toggleValue(weekdaysFiltersState, filter))}
            />
          </div>
        </div>
      </div>
    ) : (
      !_.isNull(apiError) ? (
        <span className="alert alert-danger">{apiError.message}</span>
      ) : (
        <div className="stat_page__no_data">
          <div className="col-xs-6 col-xs-offset-3 text-center">
            <i className="icon-smiley-down" />
            <p className="top-buffer-30">
              {I18n.tr('order.statistics.no_data')}
            </p>
          </div>
        </div>
      )
    )
  )
}

View.propTypes = {
  data: PropTypes.object.isRequired,
  orderModes: PropTypes.array.isRequired,
  sourcesList: PropTypes.array.isRequired,
  paymentMethods: PropTypes.array.isRequired,
  apiError: PropTypes.object,
  salesFilters: PropTypes.object.isRequired,
  salesFiltersState: PropTypes.array,
  weekdaysFilters: PropTypes.object.isRequired,
  weekdaysFiltersState: PropTypes.array,
  changeFilters: PropTypes.function,
  currencyCode: PropTypes.string,
}

export default View



// WEBPACK FOOTER //
// ./scripts/pages/order/statistics/View.js